import React from 'react'
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import FormSelect from "../../../components/atoms/Select";
import {handleFind} from "../../../helper/utils";
import ActionGenericModal from "../../../components/modal/ActionGenericModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import CrearDocumento from "./modales/CrearDocumento/CrearDocumento";


const TableAdminListarDocumentos = ({
                                        formValues,
                                        setFormValues,
                                        extraData,
                                        setModalEnabled,
                                        paginator,
                                        setPaginator,
                                        keys: KEYS,
                                        isAdmin,
                                        manageSearch
                                    }) => {
    const rows = formValues.Items;


    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},
        {col: "col-sm-1", label: "Actividad"},
        {col: "col-sm-2", label: "Flujo Documento"},
        {col: "col-sm-2", label: "Fecha Inicio"},
        {col: "col-sm-2", label: "Fecha Fin"},
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsAreas)}
                        description="Área"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsAreas] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsAreas)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsTipoDistribucion)}
                        description="Tipo Dstribución"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsTipoDistribucion] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsTipoDistribucion)}
                    />
                </div>
        },
        {col: "", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    const handleActionRow = ({row, api, title, actionLabel}) => {
        const payload = {IdSolicitudBeneficio: row.IdSolicitudBeneficio};
        const data = {
            api,
            title,
            actionLabel,
            payload,
            name: `${row.NombreEmpleado}, con Monto: ${row.Monto}`
        };
        setModalEnabled({isEnable: true, component: ActionGenericModal, data});
    }

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row, i) => (
                <tr key={i}>
                    <td className="text-center">{row.FechaRegistro}</td>
                    <td className="text-center">{row.NombreActividad}</td>
                    <td className="text-center">{row.NombreFlujoDocumento}</td>
                    <td className="text-center">{row.FechaInicio}</td>
                    <td className="text-center">{row.FechaFin}</td>
                    <td className="text-center">{row.AreaAdministrador}</td>
                    <td className="text-center">{row.TipoDistribucion}</td>
                    <td className="text-center">
                        <ActionsIcons>
                            {/*
                             {row.MotivoRechazo &&
                                <ToolTip id={`MotivoRechazo${row.IdSolicitudBeneficio}`} text={row.MotivoRechazo}/>
                            }
                            {row.PuedeDesactivar &&
                                <FontAwesomeIcon
                                    icon={row.PuedeDesactivar ? "ban" : "circle-notch"}
                                    className=''
                                    size='lg'
                                    title={`${row.PuedeDesactivar ? "Inactivar" : "Activar"}`}
                                    onClick={() => handleActionRow({
                                        row,
                                        api: inactivarSolicitudBeneficioAPI,
                                        title: `${row.PuedeDesactivar ? "Inactivar": "Activar" }`,
                                        actionLabel: `${row.PuedeDesactivar ? "inactivar": "activar" }`
                                    })}
                                />
                            }
                            */}

                            <FontAwesomeIcon
                                icon="id-card"
                                title="Ver Detalle Solicitud"
                                size="lg"
                                onClick={() =>
                                    setModalEnabled({
                                        isEnable: true,
                                        component: CrearDocumento,
                                        data: {IdFlujoDocumento: row.IdFlujoDocumento, refreshPage: manageSearch, disableInputs: false, isCreate: false},
                                    })
                                }
                            />
                        </ActionsIcons>
                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

export default TableAdminListarDocumentos;

const ToolTip = ({id, text}) => (
    <div>
        <FontAwesomeIcon data-tip data-for={id} icon='info-circle' title='Motivo Rechazo' size='lg'
                         style={{color: "#b3a11a"}}/>
        <ReactTooltip id={id} place="top" effect="solid" className="tooltip-style">
            Motivo de Rechazo: {text}
        </ReactTooltip>
    </div>
)
